module.exports = __webpack_public_path__ + "img/quartel.d58a9c4f.jpg";